import MuiAppBar from "@mui/material/AppBar";
import MuiDrawer from "@mui/material/Drawer";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import { createTheme, styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { useContext } from "react";
import AppContextProvider from "../../components/contextProvider/AppContextProvider/AppContext";
import Orders from "./Orders";
import Orders1 from "./Orders1";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://material-ui.com/">
        Your Website
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
  },
}));
 
const mdTheme = createTheme();

function TableSection() {
  const [open, setOpen] = React.useState(true);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  const { freqValue } =
  useContext(AppContextProvider);

  const renderSwitch=(param)=>{
    switch(param){
      case 'MTD':
        return "Monthly";
      case 'LTD':
        return "LTD";
      case 'YTD':
        return "Yearly";
      case 'QTD':
      return "Quarterly";
      case 'HTD':
      return "Half Yearly";
    }
  }
  const Title=renderSwitch(freqValue).concat(' Amount Disbursed & Reedemed by Month ');
  return (
    <Grid container spacing={2} sx={{mt: 1}}>
      <Grid item xs={12} md={6} lg={6}>
        <Paper elevation={2} sx={{ p: 2, display: "flex", flexDirection: "column" , minHeight:'400px'}} className="tables-section">
          <Orders 
            title = {Title}
            data = {["Month", "Amount Disbursed", "Amount Reedemed"]}
          />
        </Paper>
      </Grid>
      <Grid item xs={12} md={6} lg={6}>
        <Paper elevation={2} sx={{ p: 2, display: "flex", flexDirection: "column", minHeight:'400px' }} className="tables-section">
          <Orders1 
            title = "Amount Disbursed & Reedemed by Product"
            data = {["Product", "Amount Disbursed", "Amount Reedemed"]}
          />
        </Paper>
      </Grid>
    </Grid>
  );
}

export default TableSection;
